module Meevo.Components.Controls.SmartMover {
    import ProductCategory = Model.ProductCategory;
    import ProductSubCategory = Model.ProductSubCategory;


    export class ProductCategoriesToSubCategoriesStrategy implements ICollectionPopulate {
        constructor(private parent: ICollectionBase<ProductCategory>, private child: ICollectionBase<ProductSubCategory>) {
        }

        populate(): void {
            for (const productCategory of this.parent.models) {
                (<ISmartMoverCategoryModel<ProductCategory>>productCategory).resetModels(
                    this.child.models.filter((productSubCategory) => productSubCategory.get('catId') === productCategory.get('id'))
                );
            }
        }
    }
}